// src/components/Presidente/PresidenteForm.jsx
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { criarPresidente } from '../../services/presidenteService';

/**
 * Formulário para nomeação de presidente.
 * @param {Object} props
 * @param {Function} props.onSuccess Callback executado após nomeação bem-sucedida.
 */
const PresidenteForm = ({ onSuccess }) => {
  const [usuarioId, setUsuarioId] = useState('');
  const [departamento, setDepartamento] = useState('');
  const [dataNomeacao, setDataNomeacao] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const payload = {
        usuarioId: Number(usuarioId),
        departamento: departamento.trim(),
        dataNomeacao // formato YYYY-MM-DD
      };

      await criarPresidente(payload);
      onSuccess();

      // limpar campos
      setUsuarioId('');
      setDepartamento('');
      setDataNomeacao('');
    } catch (err) {
      console.error('Erro ao nomear presidente:', err);
      setError('Falha ao nomear presidente. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div>
        <label>
          ID do Usuário:
          <input
            type="number"
            value={usuarioId}
            onChange={(e) => setUsuarioId(e.target.value)}
            disabled={loading}
            required
          />
        </label>
      </div>
      <div>
        <label>
          Departamento:
          <input
            type="text"
            value={departamento}
            onChange={(e) => setDepartamento(e.target.value)}
            disabled={loading}
            required
          />
        </label>
      </div>
      <div>
        <label>
          Data de Nomeação:
          <input
            type="date"
            value={dataNomeacao}
            onChange={(e) => setDataNomeacao(e.target.value)}
            disabled={loading}
            required
          />
        </label>
      </div>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <button type="submit" disabled={loading}>
        {loading ? 'Nomeando...' : 'Nomear Presidente'}
      </button>
    </form>
  );
};

PresidenteForm.propTypes = {
  onSuccess: PropTypes.func.isRequired
};

export default PresidenteForm;